import { Box, Collapse, ListItemButton, MenuItem, Typography, useTheme } from '@mui/material'
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined'
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined'
import { SvgIconComponent } from '@mui/icons-material'
import { ReactNode, useState } from 'react'
import { MenuVariant } from './types'

interface MenuItemCollapsibleProps {
  variant: MenuVariant
  icon: SvgIconComponent
  title: string
  children: ReactNode
  onClick?: () => void
}

export function MenuItemCollapsible({
  variant,
  icon: Icon,
  title,
  children,
  onClick
}: MenuItemCollapsibleProps) {
  const theme = useTheme()
  const [open, setOpen] = useState(false)

  const handleToggle = () => {
    setOpen(!open)
    if (!open && onClick) {
      onClick()
    }
  }

  const isDesktop = variant === 'desktop'

  const buttonStyles = {
    px: isDesktop ? theme.spacing(3) : undefined,
    py: 1,
    flexGrow: 0,
    width: '100%'
  }

  const iconStyles = {
    color: theme.palette.grey[900]
  }

  const typographyStyles = {
    ml: !isDesktop ? theme.spacing(3 / 2) : undefined,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }

  const ButtonComponent = (isDesktop ? MenuItem : ListItemButton) as React.ElementType
  const typographyVariant = isDesktop ? 'body1' : 'h6'

  return (
    <Box>
      <ButtonComponent sx={buttonStyles} onClick={handleToggle}>
        <Icon sx={iconStyles} />

        <Typography variant={typographyVariant} color="grey.900" sx={typographyStyles}>
          <span>{title}</span>
          {open ? <ArrowDropUpOutlinedIcon /> : <ArrowDropDownOutlinedIcon />}
        </Typography>
      </ButtonComponent>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box pl={4}>{children}</Box>
      </Collapse>
    </Box>
  )
}
